import React, { use } from "react";
import { DmsAppContext } from "@dms/types/ContextTypes";
import { DiffOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";

const ItemsTemplate = () => {
    const { selectedRowKeys } = use(DmsAppContext);

    return (
        <div>
            <DiffOutlined /> <FormattedMessage id={"app.dms.moveTo"} />{" "}
            <FormattedMessage id={"app.dms.totalDocuments"} values={{ count: selectedRowKeys.length ?? 1 }} />
        </div>
    );
};

export default ItemsTemplate;
